// A nice helper to tell us if we're on the server
export const isServer = !(typeof window !== 'undefined' && window.document && window.document.createElement);
//Workaround to not let webpack replace process.env in final build
//EXEC_ENV needs to be evaluated at runtime
export const isK8S = isServer && process?.['e' + 'nv']?.EXEC_ENV === 'k8s';
